export const getEventId = (event) => event?.id || event?._id || '';

export const isRecommendationActive = (recommendation, now = new Date()) => {
  if (!recommendation) return false;

  const nowTime = now instanceof Date ? now.getTime() : new Date(now).getTime();
  const startTime = new Date(recommendation.starts_at).getTime();
  const endTime = recommendation.ends_at ? new Date(recommendation.ends_at).getTime() : null;

  if (!Number.isFinite(nowTime) || !Number.isFinite(startTime)) return false;
  return startTime <= nowTime && (endTime === null || (Number.isFinite(endTime) && endTime > nowTime));
};

export const decorateEventsWithDiscovery = (
  events = [],
  recommendations = [],
  trendingScores = [],
  now = new Date()
) => {
  const recommendationMap = new Map(
    recommendations
      .filter(recommendation => isRecommendationActive(recommendation, now))
      .map(recommendation => [recommendation.event_id, recommendation])
  );
  const trendingMap = new Map(
    trendingScores.map(score => [score.event_id, score])
  );

  return events.map(event => {
    const eventId = getEventId(event);
    const recommendation = recommendationMap.get(eventId) || null;
    const trending = trendingMap.get(eventId) || null;

    return {
      ...event,
      recommendation,
      recommendationType: recommendation?.recommendation_type || null,
      recommendationPriority: recommendation?.priority ?? null,
      recentApprovedCount: trending?.recent_approved_count || 0,
      trendingScore: trending?.trending_score || 0,
      isTrending: Boolean(trending)
    };
  });
};

export const compareTrendingEvents = (first, second) => (
  (second.trendingScore || 0) - (first.trendingScore || 0) ||
  (second.recentApprovedCount || 0) - (first.recentApprovedCount || 0) ||
  (first.date || '').localeCompare(second.date || '') ||
  (second.created_at || '').localeCompare(first.created_at || '')
);

export const splitDiscoverySections = (events = [], { recommendationLimit = 2, trendingLimit = 2 } = {}) => {
  const recommendations = events
    .filter(event => Boolean(event.recommendation))
    .sort((first, second) =>
      (second.recommendationPriority || 0) - (first.recommendationPriority || 0) ||
      (second.recommendation?.starts_at || '').localeCompare(first.recommendation?.starts_at || '')
    )
    .slice(0, recommendationLimit);

  const recommendationIds = new Set(recommendations.map(getEventId));
  const trending = events
    .filter(event => event.isTrending && !recommendationIds.has(getEventId(event)))
    .sort(compareTrendingEvents)
    .slice(0, trendingLimit);

  const featuredIds = new Set([...recommendations, ...trending].map(getEventId));
  const upcoming = events.filter(event => !featuredIds.has(getEventId(event)));

  return { recommendations, trending, upcoming };
};
